var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4096 59.98C54.2305 65.1583 46.2125 65.7424 40.3916 61.7445C39.6477 61.2244 38.9396 60.6402 38.2793 59.98C37.9394 59.6412 37.619 59.2916 37.3171 58.9235C36.7133 58.1884 36.1844 57.4044 35.7511 56.5944C34.9876 55.2263 34.4685 53.7746 34.1851 52.274C33.2706 47.568 34.6379 42.5027 38.2793 38.863C41.9293 35.2125 46.9956 33.8542 51.7023 34.7597C53.2021 35.0518 54.6551 35.5708 56.0235 36.3255C56.8347 36.7685 57.608 37.2973 58.3443 37.901C58.7113 38.2018 59.061 38.5232 59.3999 38.863C60.0612 39.5232 60.6542 40.2301 61.1646 40.9749C65.1644 46.7938 64.579 54.8115 59.4096 59.98Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9651 58.96C52.5769 64.3492 43.8449 64.3482 38.4557 58.96C33.0735 53.5778 33.0735 44.8448 38.4627 39.4566C43.8449 34.0744 52.5769 34.0744 57.9591 39.4566C63.3473 44.8448 63.3473 53.5778 57.9651 58.96ZM60.7294 36.6872C53.8132 29.7709 42.6056 29.7709 35.6894 36.6872C28.7742 43.6024 28.7682 54.817 35.6834 61.7332C41.978 68.0258 51.844 68.5933 58.7833 63.4267C59.4611 62.9213 60.1138 62.3548 60.7364 61.7332C61.3581 61.1105 61.9246 60.4578 62.4289 59.78C67.5955 52.8397 67.023 42.9808 60.7294 36.6872Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9457 87.8038L87.6554 88.0942C85.7344 90.0161 82.5888 90.0161 80.6668 88.0942L62.9297 70.3571L70.2086 63.0781L87.9457 80.8152C89.8677 82.7372 89.8677 85.8819 87.9457 87.8038Z",
    fill: "#39A1F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8021 59.2383L68.0435 64.4797L64.3224 68.1997L59.082 62.9583C59.7737 62.4427 60.4387 61.8646 61.075 61.2303C61.7094 60.5959 62.2874 59.9299 62.8021 59.2383Z",
    fill: "#98A2B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6792 80.598L80.4466 87.8296L79.1445 86.5265L86.3762 79.2949L87.6792 80.598Z",
    fill: "#1085E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.605 63.3304L63.1743 70.7612L62.0703 69.6574L69.501 62.2266L70.605 63.3304Z",
    fill: "#1085E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/searchEmpty.ffcf7bc00c762a7893586e360d6ba3cb.svg";
export { ForwardRef as ReactComponent };